import * as moment from 'moment';

export enum DateStepSize {
  Small,
  Large
}

export enum DateStepDirection {
  Previous,
  Next
}

export class StartEndDateChange {
  startDate: string;
  endDate: string;

  constructor(startDate: string, endDate: string) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export class MetricMomentChange {
  startDate: moment.Moment;
  endDate: moment.Moment;

  constructor(startDate: moment.Moment, endDate: moment.Moment) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export class DateStepChange {
  size: DateStepSize;
  direction: DateStepDirection;

  constructor(size: DateStepSize, direction: DateStepDirection) {
    this.size = size;
    this.direction = direction;
  }
}

export class MomentChangeOptions {
  steps: moment.DurationInputArg1;
  units: moment.unitOfTime.DurationConstructor;
  direction: DateStepDirection;
}
